import { useSyncExternalStore } from "react";
import { themePresets } from "@outpave/ds";
import type { ThemePresetName } from "@outpave/ds";

// Temporary test switch for DS theme presets; persisted per browser only.
const STORAGE_KEY = "outpave-theme-preset";

export const THEME_PRESETS_ENABLED =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_SENTRY_ENV === "development" ||
  process.env.REACT_APP_SENTRY_ENV === "stage";

export const THEME_PRESET_NAMES = Object.keys(
  themePresets,
) as ThemePresetName[];

export const isThemePresetName = (value: unknown): value is ThemePresetName =>
  typeof value === "string" && (THEME_PRESET_NAMES as string[]).includes(value);

const readStored = (): ThemePresetName => {
  if (!THEME_PRESETS_ENABLED) return "house";
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isThemePresetName(stored)) return stored;
  } catch {
    // Storage unavailable.
  }
  return "house";
};

let current: ThemePresetName = readStored();
const listeners = new Set<() => void>();

export const setThemePreset = (next: ThemePresetName) => {
  current = next;
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // Storage unavailable.
  }
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useThemePreset = () =>
  useSyncExternalStore(subscribe, () => current);
